import {
  ExamLocationRequestWorkflowStepCode,
  useAdminGetExamRoomRequestInfoByIdQuery,
} from '@exam-center/graphql';
import { Navigate } from '@exam-center/router';
import { Loading } from '@shared/components';
import { createContext, useMemo } from 'react';

import type {
  AdminExamRoomRequestInfoContextValue,
  AdminExamRoomRequestInfoProviderProps,
} from './types';

const AdminExamRoomRequestInfoContext = createContext<
  AdminExamRoomRequestInfoContextValue | undefined
>(undefined);

export default function AdminExamRoomRequestInfoProvider(
  props: Readonly<AdminExamRoomRequestInfoProviderProps>,
) {
  const { children, roomRequestId } = props;

  const {
    data,
    loading: isLoading,
    // error,
  } = useAdminGetExamRoomRequestInfoByIdQuery({
    variables: {
      adminGetExamRoomRequestInfoByIdInput: {
        id: roomRequestId,
      },
    },
  });

  const examRoomRequestInfo = data?.ecAdminGetExamRoomRequestInfoById?.examRoomRequestInfo;

  const contextValue: AdminExamRoomRequestInfoContextValue = useMemo(() => {
    return {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      examRoomRequestInfo: examRoomRequestInfo!,
      examLocationRequestInfo: examRoomRequestInfo?.examLocationRequestInfo ?? null,
    };
  }, [examRoomRequestInfo]);

  if (isLoading) {
    return <Loading sx={{ height: '100%' }} />;
  }

  if (
    examRoomRequestInfo?.step === ExamLocationRequestWorkflowStepCode.ExamLocationRequestApproved
  ) {
    return <Navigate to='/admin/exam-location/locations' />;
  }

  // TODO: handle errors
  // if (error || !examRoomRequestInfo) {
  //   return (
  //     <Navigate
  //       to='/admin/exam-location/locations'
  //       replace
  //     />
  //   );
  // }

  return (
    <AdminExamRoomRequestInfoContext.Provider value={contextValue}>
      {children}
    </AdminExamRoomRequestInfoContext.Provider>
  );
}

export { AdminExamRoomRequestInfoContext };
